import moment from "moment"

export const dateFormate=(dateFormate,formate)=>{
    let fdate= moment(dateFormate).format(formate?formate:"YYYY-MM-DD");
    return fdate
}